import React, { useState } from "react";
import axios from "axios";
import Header from "../components/HeaderBar";

const requiredFiles = [
  "TblAgriFisheriesMulti", "TblAgrifishgear", "TblAgrifishvessel",
  "TblAgriGamitPangsakahanMulti", "TblAgriGulayanMulti", "TblAgriHayopMulti", "TblAgriowner",
  "TblAgriTanimMulti", "TblBakunaInc", "TblHead", "TblHeadCrime", "TblHeadSasakyanMulti",
  "TblHeadTanimHGubatMulti", "TblHHappliances", "TblHHBakunaMulti", "TblHHcalamity_53",
  "TblHHcalamity_55", "TblHHDipirmihanMulti", "TblHHinsuranceMulti", "TblHHInternetMulti",
  "TblHHKapansananMulti", "TblHHMicroNutrientMulti", "TblHHMulti", "TblHHOrgMulti",
  "TblHHPhoneMulti", "TblHHSakitMulti", "TblHHSkillMulti", "TblHHTSIbasura",
  "TblHHTSIcooking", "TblHHTSIwater", "TblHHTSIwater_general", "Tblnipamulti",
  "TblOPTdata", "Tblpetdogmulti", "TblPetMulti", "tbltmp", "TblYear"
];

function Migrate() {
  const [files, setFiles] = useState([]);
  const [missingFiles, setMissingFiles] = useState([]);
  const [extraFiles, setExtraFiles] = useState([]);
  const [isUploadDisabled, setUploadDisabled] = useState(true);
  const [isUploading, setUploading] = useState(false);




    const handleFileChange = (e) => {
        const uploadedFiles = Array.from(e.target.files);
        setFiles(uploadedFiles);

        const uploadedFileNames = uploadedFiles.map(file => file.name.replace(".xlsx", "")); // ✅ Extract filenames

        // Check missing files correctly
        const missing = requiredFiles.filter(file => !uploadedFileNames.includes(file));
        setMissingFiles(missing);

        // Identify extra uploaded files properly
        const extra = uploadedFileNames.filter(file => !requiredFiles.includes(file));
        setExtraFiles(extra);

        setUploadDisabled(missing.length > 0 || extra.length > 0); // ✅ Use corrected extra file check
    };

    const handleUpload = async () => {
    if (files.length === 0) {
        alert("Please select a folder with .xlsx files.");
        return;
    }

    setUploading(true); // ✅ Disable button while uploading

    const formData = new FormData();
    files.forEach((file) => {
        formData.append("tbl", file); // ✅ Sends actual file, not just filename
    });

    try {
        await axios.post(`${process.env.REACT_APP_API_URL}/api/migrate_tbl`, formData, {
        headers: {'x-api-key': process.env.REACT_APP_API_KEY},
        });
        alert("Upload successful!");
    } catch (error) {
        console.error("Error uploading files", error);
        alert("Upload failed.");
    }

    setUploading(false); // ✅ Re-enable button after response

    };

  return (
    <div style={containerStyle}>
      {/* <Header /> */}
      <div style={uploadBoxStyle}>
        <h2 style={headingStyle}>Upload FOLDER with BMIS tables</h2>
        <input type="file" webkitdirectory="true" multiple onChange={handleFileChange} style={inputStyle} />
        <button
            onClick={handleUpload}style={buttonStyle(isUploadDisabled || isUploading)} disabled={isUploadDisabled || isUploading}>
            {isUploading ? "Uploading..." : "Upload Files"} {/* ✅ Change text dynamically */}
        </button>

        
        <div style={fileListContainer}>
                    
            {/* Display extra uploaded files (not required) */}
            {extraFiles.length > 0 && (
            <div style={extraFileListContainer}>
                <h4 style={{ textAlign: "left", marginBottom: "10px", color: "#ff9900" }}>Unexpected Files ⚠️</h4>
                <div style={fileListGrid}>
                {extraFiles.map((file, index) => ( // ✅ file is now correctly a name, not an object
                    <div key={index} style={extraFileItemStyle}>
                    ⚠️ {file}.xlsx
                    </div>
                ))}
                </div>
            </div>
            )}

            {/* Display missing files with ❌ icon */}
            {missingFiles.length > 0 && (
            <div style={missingFileListContainer}>
                <h4 style={{ textAlign: "left", marginBottom: "10px", color: "#ff3333" }}>Missing Files ❌</h4>
                <div style={fileListGrid}>
                {missingFiles.map((file, index) => (
                    <div key={index} style={missingFileItemStyle}>
                    ❌ {file}.xlsx {/* ✅ Displays correctly now */}
                    </div>
                ))}
                </div>
            </div>
            )}

            {/* Required Files List */}
            <h4 style={{ textAlign: "left", marginBottom: "10px" }}>Uploaded Files:</h4>
            <div style={fileListGrid}>
                {files.map((file, index) => (
                <div key={index} style={fileItemStyle}>
                    ✅ {file.name} {/* ✅ Access `.name` instead of rendering raw `File` object */}
                </div>
                ))}
            </div>


        </div>

      </div>
    </div>
  );
}

// Styling for better UI consistency
const containerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "80px", // ✅ Matches the header height to prevent shifting
  height: "calc(100vh - 80px)", // ✅ Ensures equal content positioning across pages
  width: "100%", // ✅ Maintains consistent scaling
  background: "#f8f9fa"

};

const uploadBoxStyle = {
  width: "40%",
  padding: "30px",
  backgroundColor: "#ffffff",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  borderRadius: "10px",
  textAlign: "center"
};

const headingStyle = {
  marginBottom: "20px",
  fontSize: "24px",
  fontWeight: "bold",
  color: "#333"
};

const inputStyle = {
  marginBottom: "20px",
  padding: "10px",
  border: "1px solid #ddd",
  borderRadius: "5px",
  width: "100%"
};

const buttonStyle = (disabled) => ({
  padding: "12px 20px",
  fontSize: "16px",
  backgroundColor: disabled ? "#B0B0B0" : "#007bff", // ✅ Gray when disabled
  color: "#ffffff",
  border: "none",
  borderRadius: "5px",
  cursor: disabled ? "not-allowed" : "pointer", // ✅ Shows "not-allowed" cursor when disabled
  width: "100%",
  fontWeight: "bold",
  transition: "0.3s ease-in-out", // Smooth color transition
});


const fileListContainer = {
  marginTop: "20px",
  backgroundColor: "#ffffff",
  padding: "15px",
  borderRadius: "5px",
  boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
  maxHeight: "300px", // ✅ Limits height and makes it scrollable
  overflowY: "auto", // ✅ Enables vertical scrolling
};

const fileListGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)", // ✅ Creates 2 columns
  gap: "15px",
};

const fileItemStyle = {
  padding: "5px",
  fontSize: "16px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const extraFileListContainer = {
  marginTop: "15px",
  backgroundColor: "#fff3cd",
  padding: "10px",
  borderRadius: "5px",
  boxShadow: "0px 2px 5px rgba(255, 153, 0, 0.2)"
};

const extraFileItemStyle = {
  padding: "5px",
  fontSize: "16px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  color: "#ff9900", // Warning color
};

const missingFileListContainer = {
  marginTop: "15px",
  backgroundColor: "#ffdddd", // ✅ Light red background to highlight missing files
  padding: "10px",
  borderRadius: "5px",
  boxShadow: "0px 2px 5px rgba(255, 0, 0, 0.2)"
};

const missingFileItemStyle = {
  padding: "5px",
  fontSize: "16px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  color: "#ff3333", // ✅ Strong red text for visibility
};

export default Migrate;